import request from '@/utils/http';
// 查询列表
export const getSourceRoot = (params) => {
    return request({
        url: `/api-tms/appointment/transport/group/search`,
        method: 'post',
        data: params
    }).then(res => res);
};
// 查询tk单
export const getSourceData = (params) => {
    return request({
        url: `/api-tms/appointment/transport/search`,
        method: 'post',
        data: params
    }).then(res => res);
};
export const getDictList = (params) => {
    return request({
        url: `/api-mdm/dictionaryDetail/dict`,
        method: 'get',
        params
    });
};
export const getTargetRoot = (data) => {
    return request({
        url: `/api-tms/dispatch/list`,
        method: 'post',
        data
    }).then(res => res);
};
export const getTargetData = (data) => {
    return request({
        url: `/api-tms/transport/list/sort`,
        method: 'post',
        data
    }).then(res => res);
};
export const getDetailStatistics = (data) => {
    return request({
        url: `/api-tms/transport/itemdeail/count`,
        method: 'post',
        data
    }).then(res => res);
};
export const getStorageData = (params) => {
    return request({
        url: `/api-tms/dispatch/distribution/search`,
        method: 'get',
        params
    }).then(res => res);
};
export const getAllocate = (data) => {
    return request({
        url: `/api-tms/dispatch/distribution/update/${data.taskNo}`,
        method: 'put',
        data
    }).then(res => res);
};
export const getCancleAllocate = (data) => {
    return request({
        url: `/api-tms/dispatch/distribution/cancel`,
        method: 'put',
        data
    }).then(res => res);
};
export const saveCarArrange = (data) => {
    return request({
        url: `/api-tms/dispatch/artificial/save`,
        method: 'post',
        data
    }).then(res => res);
};
export const intelligentDispatch = (data) => {
    return request({
        url: `/api-tms/dispatch/intelligent`,
        method: 'post',
        data
    }).then(res => res);
};
export const updateCarArrange = (data) => {
    return request({
        url: `/api-tms/transport/operate`,
        method: 'post',
        data
    }).then(res => res);
};
export const updateIntelliArrange = (data) => {
    return request({
        url: `/api-tms/intelligent/operate`,
        method: 'post',
        data
    }).then(res => res);
};
export const getTransferData = (data) => {
    return request({
        url: `/api-tms/transport/transfer`,
        method: 'post',
        data
    }).then(res => res);
};
export const getTabelExpandDetail = (data) => {
    return request({
        url: `/api-tms/transport/itemdeail`,
        method: 'post',
        data
    }).then(res => res);
};
// 修改配送方式页面获取网点信息
export const searchNetInfo = (data) => {
    return request({
        url: `/api-tms/transports/searchNetinfo`,
        method: 'post',
        data
    }).then(res => res);
};
// 修改配送方式
export const updateDeliveryMethods = (data) => {
    return request({
        url: `/api-tms/transport/distributionModeUpdate`,
        method: 'post',
        data
    }).then(res => res);
};
// 查询网点信息
export const netInfos = (params) => {
    return request({
        url: `/api-mdm/netInfos`,
        method: 'get',
        params
    });
};
export const issueCarrier = (data) => {
    return request({
        url: `/api-tms/transport/issueCarrier`,
        method: 'put',
        data
    });
};
export const confirmIssueCarrier = (data) => {
    return request({
        url: `/api-tms/transport/confirmIssueCarrier`,
        method: 'put',
        data
    });
};
// 获取详细地址
export const searchCountryByHistory = (data) => {
    return request({
        url: '/api-otp/searchagg/gis/searchCountryByKeywords',
        method: 'post',
        data
    }).then(res => res);
};
// 网络调车验证是否需要获取授权
export const checkLogin = (data) => {
    return request({
        url: '/api-tms/mb/checkLogin',
        method: 'post',
        data
    });
};
// 网络调车获取短信验证码
export const sendVerify = (data) => {
    return request({
        url: `/api-tms/mb/sendVerify/${data}`,
        method: 'get'
    });
};
// 网络调车获取授权
export const authorize = (data) => {
    return request({
        url: '/api-tms/mb/authorize',
        method: 'post',
        data
    });
};
// 一键网络调车保存接口
export const saveCargoDeploy = (data) => {
    return request({
        url: '/api-tms/mb/saveCargoDeploy',
        method: 'post',
        data
    });
};
// 满帮查询联系人
export const searchCategoryContact = (data) => {
    return request({
        url: '/api-tms/mb/searchCategoryContact',
        method: 'post',
        data
    });
};
// 满帮新增、修改联系人
export const updateCategoryContact = (data) => {
    return request({
        url: '/api-tms/mb/updateCategoryContact',
        method: 'post',
        data
    });
};
// 满帮删除联系人
export const deleteCategoryContact = (data) => {
    return request({
        url: '/api-tms/mb/deleteCategoryContact',
        method: 'post',
        data
    });
};
// 获取线路标准成本
export const getTargetCost = (data) => {
    return request({
        url: '/api-tms/mb/queryTargetCost',
        method: 'post',
        data
    });
};
// 获取线路标准成本
export const getCargoApi = (data) => {
    return request({
        url: '/api-tms/mb/category',
        method: 'post',
        data
    });
};
// 重新发布查询数据接口
export const searchCargoDetail = (params) => {
    return request({
        url: `/api-tms/mb/searchCargoDeteil`,
        method: 'post',
        data: params
    });
};
// 重新发布保存接口
export const rePublishSave = (data) => {
    return request({
        url: `/api-tms/mb/reboot`,
        method: 'post',
        data
    });
};
// 验证订单分析白名单
export const siteCodeWhiteList = (data) => {
    return request({
        url: `/api-tms/order/user/site/check`,
        method: 'get'
    });
};
// 取消原因
export const cancelReason = (data) => {
    return request({
        url: `/api-tms/order/userfeedback/add`,
        method: 'post',
        data
    });
};
// 线路调度分组查询
export const selectLineScheduleGroup = (data) => {
    return request({
        url: `/api-tms/transportExtend/selectLineScheduleGroup`,
        method: 'post',
        data
    });
};
// 批量分拨保存接口
export const saveAllocateApi = (data) => {
    return request({
        url: `/api-tms/transportExtend/distribute`,
        method: 'post',
        data
    });
};
// 分拨查询接口
export const lineCodeApi = (data) => {
    return request({
        url: `/api-tms/preDispatch/distributionRoute/query`,
        method: 'get',
        params: data
    });
};
// 排车保存
export const saveCarArrangeApi = (data) => {
    return request({
        url: `/api-tms/preDispatch/lineDispatch`,
        method: 'post',
        data
    });
};
// 排车保存
export const checkAllocateApi = (data) => {
    return request({
        url: `/api-tms//transportExtend/calculateLineRouteTime`,
        method: 'post',
        data
    });
};
// 获取筛单规则数据
export const getServeRule = (data) => {
    return request({
        url: `/api-tms/transportChoose/searchList`,
        method: 'post',
        data
    }).then(res => res);
};
// 更改排车方式
export const changeDispatchApi = (data) => {
    return request({
        url: `/api-tms/transportExtend/changeDispatch`,
        method: 'post',
        data
    }).then(res => res);
};
// 批量分拨
export const batchAllocateApi = (data) => {
    return request({
        url: `/api-tms/dispatch/distribution/update/batch`,
        method: 'post',
        data
    });
};
// 预约记录
export const getAppointmentRecordApi = (data) => {
    return request({
        url: '/api-tms/appointment/record/query',
        method: 'post',
        data
    });
};
// 拨号记录
export const getDialingRecordApi = (data) => {
    return request({
        url: '/api-tms/appointment/call/record/query',
        method: 'post',
        data
    });
};
// 批量预约/预约/改约
export const batchAppointmentApi = (data) => {
    return request({
        url: '/api-tms/appointment/operate',
        method: 'post',
        data
    });
};
// 预约/改约,回显数据
export const appointmentApi = (data) => {
    return request({
        url: '/api-tms/appointment/record/get',
        method: 'post',
        data
    });
};
// 分配、批量分配
export const allocationApi = (data) => {
    return request({
        url: '/api-tms/appointment/assign/task',
        method: 'post',
        data
    });
};
// 获取预约信息
export const getTransportAppointmentListApi = (data) => {
    return request({
        url: '/api-tms/appointment/transport/list',
        method: 'post',
        data
    });
};
// 获取逆向预约信息
export const getReverseTransportAppointmentListApi = (data) => {
    return request({
        url: '/api-tms/appointment/transport/reverse/list',
        method: 'post',
        data
    });
};
// 获取用户服务平台权限
export const getUserSiteCodeApi = (data) => {
    return request({
        url: '/api-tms/user/auth/data/site/query',
        method: 'post',
        data
    });
};

// 根据选中的tk单获取需要分配的tk单
export const getAssignQueryApi = (data) => {
    return request({
        url: '/api-tms/appointment/task/assign/query',
        method: 'post',
        data
    });
};
// 获取商品明细信息
export const getInventoryData = (data) => {
    return request({
        url: '/api-tms/appointment/transport/detail/query',
        method: 'post',
        data
    });
};
// 筛单规则新逻辑开关
export const getServeRuleSwitchQueryApi = (data) => {
    return request({
        url: `/api-tms/transport/choose/optimize/switchQuery`,
        method: 'post',
        data
    });
};
